import { WalletPlusIcon } from './WalletPlusIcon';

/**
 * author: GreenTurtwig
 * id A53A1EF4-13E1-4807-A20E-A0DA2F52392D
 * name wallet-plus
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wallet-plus.svg
 * tags
 * - Banking 
 */
export const WalletAddIcon = WalletPlusIcon;
export default WalletAddIcon